import { getHeaders } from 'auth/auth';
import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithAuth from '../baseQuery';

export const docProcessingAPI = createApi({
  reducerPath: 'docProcessing',
  tagTypes: ['DocProcessingJob'],
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getDocProcessingStatus: builder.query({
      query: ({ jobId, isConsumer = false }) => {
        const basePath = isConsumer ? '/b2c/documents' : '/b2b/documents';
        return {
          url: `${basePath}/processing_jobs/${jobId}`,
          method: 'GET',
          headers: getHeaders(),
        };
      },
      providesTags: (_result, _error, { jobId }) => [
        { type: 'DocProcessingJob', id: jobId },
      ],
    }),
  }),
});

export const {
  useGetDocProcessingStatusQuery,
} = docProcessingAPI;

export default docProcessingAPI;
